<template>
  <div class='interactives-digital-will'>
    <div class='will-title'>Digital Will Generator</div>
    <keep-alive>
      <component :is='currentView'
        :formData='setupForm'
        :formValidator='formValidator'
        :templateData='templateForm'
        @submitForm='formSubmitted'
        @back='goBack'
      >Continue</component>
    </keep-alive>
  </div>
</template>

<script>
import * as $ from 'jquery'

import Form from '../../interactives-form/src/App'
import setupForm from './assets/setupForm.json'

import WillInput from './components/WillInput'
import templateForm from './assets/templateForm.json'

import WillOutput from './components/WillOutput'

export default {
  name: 'interactives-digital-will',
  data () {
    return {
      currentViewIndex: 0,
      views: ['will-setup', 'will-input', 'will-output'],
      formValidator: function (formData) {
        return !(formData[2].value === null | (!formData[2].value & !formData[0].value.length & !formData[1].value.length))
      },
      setupForm: setupForm,
      templateForm: templateForm
    }
  },
  watch: {
    setupForm: {
      handler: function (newVal, oldVal) {
        for (var service of newVal[1].value) {
          templateForm.additional[service] = [
            {
              type: 'text-input',
              value: null,
              name: `${service}-login`,
              placeholder: 'your login'
            },
            {
              type: 'check-input',
              value: null,
              label: '[Select all that apply:]',
              name: `${service}-request`,
              options: [
                {
                  label: 'Establish a digital memorial.'
                },
                {
                  label: 'Message my regular correspondents with news of my death.'
                },
                {
                  label: 'Set up an auto reply for any future correspondents.'
                },
                {
                  label: 'Fulfill any outstanding transactions.'
                },
                {
                  label: 'Cancel any outstanding transactions.'
                },
                {
                  label: 'Cancel any outstanding transactions.'
                },
                {
                  label: 'Cancel any recurring payments.'
                },
                {
                  label: 'Remove payment options and other personal information from my account.'
                },
                {
                  label: 'Delete my search history.'
                },
                {
                  label: 'Transfer ownership of all associated digital media to the recipient specified below.',
                  value: 'transfer'
                },
                {
                  label: 'Delete my account.'
                }
              ]
            },
            {
              type: 'text-input',
              label: 'Recipient of digital media [if applicable]:',
              value: null,
              name: `${service}-recipient`,
              placeholder: 'the recipient’s full legal name'
            },
            {
              type: 'textarea-input',
              value: null,
              name: `${service}-misc`,
              placeholder: 'Write any additional requests here.'
            }
          ]
        }

        for (var key of Object.keys(templateForm.additional)) {
          if ($.inArray(key, newVal[1].value) === -1) delete templateForm.additional[key]
        }
      },
      deep: true
    }
  },
  computed: {
    currentView () { return this.views[this.currentViewIndex] }
  },
  methods: {
    goForward () { this.currentViewIndex++ },
    goBack () { this.currentViewIndex-- },
    formSubmitted () { this.goForward() }
  },
  components: {
    'will-setup': Form,
    'will-input': WillInput,
    'will-output': WillOutput
  }
}
</script>

<style lang='scss'>
.interactives-digital-will {
  width: 100%;
  max-width: 590px;
  box-sizing: border-box;
  padding: 1em;
  border: 1px solid #c7c7c7;

  * {
    box-sizing: border-box;
  }

  p {
    line-height: 1.8em;
  }

  select {
    width: 300px;
  }

  .interactives-check-input, .interactives-radio-input {
    legend {
      margin-bottom: 0.5em;
    }
    .options {
      margin-left: 1em;
    }
  }

  .continue-button, .print-button {
    color: white;
    background: #603;
    border: #c7c7c7;
    font-family: 'sl-Apres', 'Helvetica';
    padding: 0.5em;
    border-radius: 0;
  }

  .continue-button:disabled, .print-button:disabled {
    background: rgba(102, 0, 51, 0.5);
  }

  .cont-btn-c {
    text-align: center;
  }

  .back-button {
    border: none;
    background: none;
    color: #603;
    font-family: 'sl-Apres', 'Helvetica';
  }

  .will-title {
    font-family: 'sl-TitlingGothicFBCondensed', 'Helvetica';
    font-size: 2em;
    text-align: center;
    margin-bottom: 0.5em;
  }

  .interactives-form {
    .interactives-input {
      margin-bottom: 1em;
    }
  }

  .will-input-body, .will-output-body {
    padding: 0.5em;
    margin: 0.5em;
    background: #eee;
  }

  .item-close {
    border: none;
    background: none;
    font-family: 'sl-Apres', 'Helvetica';
    color: #603;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue